import React from 'react';
import { Translate } from 'react-redux-i18n';
import './not-come-out.scss';

const NotComeOut = () => {
  return (
    <div className="not-come-out">
      <div className="title">
        <i className="icon-warning mr-5" />
        <Translate value="layout.notComeOut.title" />
      </div>
      <div className="message">
        <Translate value="layout.notComeOut.message" />
      </div>
    </div>
  );
};

export default NotComeOut;
